import React from 'react';
import styled from "styled-components";
import SearchWithoutResult from "@molecules/lotties/search_without_result";

const AgenciesSearchNoResult = () => {
    return (
        <NoResults className="my-40 my-lg-56 text-center w-100">
            <div className="no-result-gif d-inline-block">
                <SearchWithoutResult/>
            </div>

            <div className="mt-24">
                <h3>موردی با این مشخصات پیدا نشد!</h3>
            </div>
        </NoResults>
    );
};

export default React.memo(AgenciesSearchNoResult);

// styles

const NoResults = styled.div`

  .no-result-gif {
    width: 300px;
    height: 300px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      width: 200px;
      height: 200px;
    }
  }
`;